/**
 * 付款方式文案。订单表（OrderEntity.payType）和付款单（PayListEntity.payType）共用
 * 后端的 ORDER_PAY_TYPE 枚举：
 * 1 微信支付 2 货到付款 4 银行卡 8 支付宝 16 优惠券全额兑换 32 余额 64 积分兑换。
 *
 * 后端 PayListEntity 上有个 payText getter，但它只认 微信/支付宝/银行卡/余额 四种，
 * 货到付款和优惠券兑换会掉进「未知付款」，所以这里自己维护一份完整的；
 * payText 留着当兜底 —— 哪天后端加了新枚举值，至少还能显示后端给的说法。
 */

const PAY_TYPE_TEXT = {
  1: "微信支付",
  2: "货到付款",
  4: "银行卡",
  8: "支付宝",
  16: "优惠券全额兑换",
  32: "余额支付",
  64: "积分兑换",
};

export function getPayTypeText(payType: any, payText?: string) {
  return PAY_TYPE_TEXT[Number(payType)] || payText || "其他方式";
}
